import React from 'react';
import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import { BaseLeadPage, CarleadHIWWhyChooseWkdaFaq, CarleadStep2CustomerPopup, } from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadStep2CustomerPopup}
      content={CarleadHIWWhyChooseWkdaFaq}
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
